import { styled } from 'goober';
export var GridLine = styled('div')(function (_a) {
    var _b = _a.$colTemplate, $colTemplate = _b === void 0 ? '1fr' : _b;
    return {
        display: 'grid',
        gridTemplateColumns: $colTemplate,
        gridGap: '10px',
        padding: '5px 0px',
    };
});
export var SimpleGrid = styled('div')(function (_a) {
    var $columnNumber = _a.$columnNumber, _b = _a.$gapSize, $gapSize = _b === void 0 ? 1 : _b;
    return {
        display: 'grid',
        gridTemplateColumns: "repeat(".concat($columnNumber, ", 1fr)"),
        gridGap: "".concat($gapSize * 10, "px"),
    };
});
export var TemplatedGrid = styled('div')(function (_a) {
    var _b = _a.$colTemplate, $colTemplate = _b === void 0 ? '1fr' : _b, _c = _a.$gapSize, $gapSize = _c === void 0 ? 1 : _c;
    return {
        display: 'grid',
        gridTemplateColumns: $colTemplate,
        gridGap: "".concat($gapSize * 10, "px"),
    };
});
